import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import get from "lodash/get";
import compose from "lodash/fp/compose";

import { Redirect } from "../../router";
import { withSubscribe, AuthContainer } from "../../state";

import LoginView from "./ui/LoginView";

class C extends React.Component {
  state = {
    redirectToReferrer: false,
  };

  handleSubmit = async (values) => {
    const { loginMutation } = this.props;
    const { auth } = this.props;
    const result = await loginMutation({ variables: values });

    const token = get(result, "data.getAuthToken.token");
    if (token) {
      await auth.setAuth(token);
      this.setState({ redirectToReferrer: true });
    } else {
      return { _error: "Invalid credentials" };
    }
  };

  render() {
    const {
      state: { from } = { from: { pathname: "/" } },
    } = this.props.location;
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }

    return <LoginView onSubmit={this.handleSubmit} />;
  }
}

const loginMutation = gql`
  mutation LoginMutation($username: String!, $password: String!) {
    getAuthToken(username: $username, password: $password) {
      token
    }
  }
`;

const LoginScene = compose(
  withSubscribe({ to: { auth: AuthContainer } }),
  graphql(loginMutation, { name: "loginMutation" })
)(C);

export default LoginScene;
